import { styled } from '@clickcease/cc-client-components-lib'

export const InvalidRequestsStyled = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
})
